export default [
  // 系统管理路由
  {
    path: 'user',
    name: 'mecs_user',
    meta: {
      title: '用户管理',
      breadcrumb: ['系统管理', '用户管理'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/system/UserManage.vue'
      ),
  },
  {
    path: 'role',
    name: 'mecs_role',
    meta: {
      title: '角色管理',
      breadcrumb: ['系统管理', '角色管理'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/system/RoleManage.vue'
      ),
  },
  {
    path: 'menu',
    name: 'mecs_menu',
    meta: {
      title: '菜单管理',
      breadcrumb: ['系统管理', '菜单管理'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/system/MenuManage.vue'
      ),
  },
  {
    path: 'logo',
    name: 'mecs_logo',
    meta: {
      title: 'Logo 设置',
      breadcrumb: ['系统管理', 'Logo 设置'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/system/LogoConfig.vue'
      ),
  },
  {
    path: '/mecs/project/map',
    name: 'map',
    meta: {
      title: '地图监控',
      breadcrumb: ['数据大屏', '地图监控'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/map.vue'
      ),
  },
  {
    path: '/mecs/project/3d-editor',
    name: '3dEditor',
    meta: {
      title: '3D 组态',
      breadcrumb: ['项目管理', '3D 组态'],
    },
    component: () =>
      import(
        /*webpackChunkName: "3DEditor" */ '@/views/mecs_views/project/3d-editor.vue'
      ),
  },
  {
    path: '/mecs/project/3d-viewer',
    name: '3dViewer',
    meta: {
      title: '3D 查看',
      breadcrumb: ['项目管理', '3D 查看'],
    },
    component: () =>
      import(
        /*webpackChunkName: "3DViewer" */ '@/views/mecs_views/project/3d-viewer.vue'
      ),
  },
  {
    path: '/mecs/project/2d-editor',
    name: '2dEditor',
    meta: {
      title: '2D 组态',
      breadcrumb: ['项目管理', '2D 组态'],
    },
    component: () =>
      import(
        /*webpackChunkName: "2DEditor" */ '@/views/mecs_views/project/2d-editor.vue'
      ),
  },
  {
    path: '/mecs/project/2d-viewer',
    name: '2dViewer',
    meta: {
      title: '2D 查看',
      breadcrumb: ['项目管理', '2D 查看'],
    },
    component: () =>
      import(
        /*webpackChunkName: "2DViewer" */ '@/views/mecs_views/project/2d-viewer.vue'
      ),
  },
  {
    path: '/mecs/project/centermonitor',
    name: 'centermonitor',
    meta: {
      title: '集中监控',
      breadcrumb: ['数据大屏', '集中监控'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/centermonitor.vue'
      ),
  },
  {
    path: '/mecs/project/workbench',
    name: 'workbench',
    meta: {
      title: '工作台',
      breadcrumb: ['项目中心', '工作台'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/workbench.vue'
      ),
  },
  {
    path: '/mecs/project/analysis',
    name: 'analysis',
    meta: {
      title: '分析页',
      breadcrumb: ['项目中心', '分析页'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/analysis.vue'
      ),
  },
  {
    path: '/mecs/project/configuration',
    name: 'configuration',
    meta: {
      title: '项目配置',
      breadcrumb: ['项目中心', '项目配置'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/configuration.vue'
      ),
  },
  {
    path: '/mecs/project/realmonitor',
    name: 'realmonitor',
    meta: {
      title: '实时监控',
      breadcrumb: ['数据分析', '实时监控'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/realmonitor.vue'
      ),
  },
  {
    path: '/mecs/project/historyreport',
    name: 'historyreport',
    meta: {
      title: '历史报表',
      breadcrumb: ['报表中心', '历史报表'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/historyreport.vue'
      ),
  },
  {
    path: '/mecs/project/report',
    name: 'report',
    meta: {
      title: '报表管理',
      breadcrumb: ['报表中心', '报表管理'],
    },
    component: () =>
      import(
        /*webpackChunkName: "ReportManagement" */ '@/views/mecs_views/project/reportmanagement.vue'
      ),
  },
  {
    path: '/mecs/project/personal',
    name: 'personal',
    meta: {
      title: '个人中心',
      breadcrumb: ['个人中心', '个人中心'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/personal.vue'
      ),
  },
  {
    path: '/mecs/project/message',
    name: 'message',
    meta: {
      title: '消息中心',
      breadcrumb: ['消息中心', '消息中心'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/message.vue'
      ),
  },
  {
    path: '/mecs/project/pushmanage',
    name: 'pushmanage',
    meta: {
      title: '推送管理',
      breadcrumb: ['消息中心', '推送管理'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/pushmanage.vue'
      ),
  },
  {
    path: '/mecs/project/activealarm',
    name: 'activealarm',
    meta: {
      title: '活跃报警',
      breadcrumb: ['报警管理', '活跃报警 '],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/activealarm.vue'
      ),
  },
  {
    path: '/mecs/project/historyalarm',
    name: 'historyalarm',
    meta: {
      title: '历史报警',
      breadcrumb: ['报警管理', '历史报警 '],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/historyalarm.vue'
      ),
  },
  {
    path: '/mecs/project/usermanage',
    name: 'usermanage',
    meta: {
      title: '用户管理',
      breadcrumb: ['人员管理', '用户管理'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/system/UserManage.vue'
      ),
  },
  {
    path: '/mecs/project/role',
    name: 'role',
    meta: {
      title: '角色管理 ',
      breadcrumb: ['人员管理', '角色管理'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/system/RoleManage.vue'
      ),
  },
  {
    path: '/mecs/project/permission',
    name: 'permission',
    meta: {
      title: '权限管理',
      breadcrumb: ['人员管理 ', '权限管理'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/system/MenuManage.vue'
      ),
  },
  {
    path: '/mecs/project/DataSource',
    name: 'DataSource',
    meta: {
      title: '数据源管理',
      breadcrumb: ['变量管理', '数据源管理'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/DataSource.vue'
      ),
  },
  {
    path: '/mecs/project/VariableManager',
    name: 'VariableManager',
    meta: {
      title: '变量配置',
      breadcrumb: ['变量管理', '变量配置'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/VariableManager.vue'
      ),
  },
  {
    path: '/mecs/project/2d-publish-manage',
    name: '2dPublishManage',
    meta: {
      title: '2D 发布管理',
      breadcrumb: ['2D 组态', '发布管理'],
    },
    component: () =>
      import(
        /*webpackChunkName: "2DPublishManage" */ '@/views/mecs_views/project/2d-publish-manage.vue'
      ),
  },
  {
    path: '/mecs/project/log',
    name: 'log',
    meta: {
      title: '操作日志',
      breadcrumb: ['操作日志', '操作日志'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Workbench" */ '@/views/mecs_views/project/log.vue'
      ),
  },
  {
    path: '/mecs/project/video',
    name: 'video',
    meta: {
      title: '视频监控',
      breadcrumb: ['视频监控', '视频监控'],
    },
    component: () =>
      import(
        /*webpackChunkName: "Video" */ '@/views/mecs_views/project/video.vue'
      ),
  },
];
